var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dry-lastYear"},[_c('moduleTitle',{attrs:{"title":"能耗统计"}}),_c('div',{staticClass:"echars"},[_c('echarts',{attrs:{"option":_vm.option}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }